import React, { useContext } from 'react';
import Button from '../../../../../Button';
import H4 from '../../../../../Text/H4';
import { AppContext } from '../../../../../AppProvider';
import {
  Container, Text, Link,
} from './styled';

function DeactivateAccount({ deactivateOrganization }) {
  const { actions: { hideModal } } = useContext(AppContext);
  return (
    <Container>
      <H4>Cancel your subscription?</H4>
      <Text>
        You will no longer be able to process donations or payments via your
        organizations form. This information can be reactivated at any time.
      </Text>
      <Button onClick={hideModal} label="Keep My Account" />
      <Link onClick={deactivateOrganization}>Cancel Subscription</Link>
    </Container>
  );
}

export default DeactivateAccount;
